import { useEffect, useState } from 'react'
import './CookieBanner.css'

function CookieBanner(){
  const [accepted, setAccepted] = useState(false)

  useEffect(()=>{
    try{
      const v = localStorage.getItem('hlb_cookies_accepted')
      if(v === '1') setAccepted(true)
    }catch(e){}
  },[])

  const accept = () => {
    try{ localStorage.setItem('hlb_cookies_accepted','1') }catch(e){}
    setAccepted(true)
  }

  if(accepted) return null

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="cookie-inner">
        <p>
          We use cookies to improve your experience. By using this site you agree to our <a href="/privacy">Privacy Policy</a>.
        </p>
        <div className="cookie-actions">
          <button className="btn ghost" onClick={accept} aria-label="Accept cookies">Accept</button>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner
